import axios from "./api";

export const getVersion = async () => {
  return axios.get(`/version.json`);
};
